<template>
  <div class='four-grids'>
    <div class='header' style='margin-top: .04rem;'>
      <div>{{ floorData.floorTitle }}</div>
      <a v-if="floorData.isMore === '0'" class='more' :href="!$isIframe ? floorData.moreUrl: 'javascript:void(0);'">
        <span>更多</span>
        <img src='@/assets/img/arrow-right.png' alt='' />
      </a>
    </div>
    <div class='gridArea'>
      <template v-if='floorData.data.length > 0'>
        <div v-for='(item, idx) in floorData.data' :key='idx'>
          <a @click='$jumpToPage(item)'>
            <img class='gridImage' :src='item.imageUrl' alt=''>
            <div class='gridTitle'>{{ item.title }}</div>
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FourGrids2',
  props: ['floorData']
}
</script>

<style lang='scss' scoped>
.four-grids {
  padding: 0 .1rem;

  .gridArea {
    display: grid;
    width: 100%;
    grid-template-columns: auto auto auto auto;
    grid-gap: 0.08rem;

    a {
      background: white;
      border-radius: 0.04rem;
      display: flex;
      flex-direction: column;
      align-items: center;

      .gridImage {
        width: 0.43rem;
        height: 0.43rem;
        margin-top: 0.1rem;
        margin-bottom: 0.04rem;
      }

      .gridTitle {
        font-size: 0.14rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #0d0d0d;
        line-height: 0.2rem;
        text-align: center;
        margin-bottom: 0.055rem;
      }
    }
  }
}
</style>
